module.exports = __webpack_public_path__ + "img/inspiration1.9566c851.png";